export const OPEN_AUFTRAGSBESTAETIGUNG_FROM_ANGEBOT_EVENT =
  "eh:open-auftragsbestaetigung-from-angebot";

export interface AuftragsbestaetigungFromAngebotEventDetail {
  angebotId: number;
}

export function requestAuftragsbestaetigungFromAngebot(angebotId: number): void {
  if (!Number.isFinite(angebotId) || angebotId <= 0) return;
  window.dispatchEvent(
    new CustomEvent<AuftragsbestaetigungFromAngebotEventDetail>(
      OPEN_AUFTRAGSBESTAETIGUNG_FROM_ANGEBOT_EVENT,
      { detail: { angebotId } },
    ),
  );
}
